// create schema using yup
import { object, string, number, array } from 'yup'

export const createKPIFormSchema = object().shape({
    employees: array().of(
        object().shape({
            employee_id: number().required(),
            product_group_name: string().required(),
            new_sale_rate: number().required(),
            renewal_rate: number().required(),
            upsale_rate: number().required(),
        })
    ),
})
